import { ProviderState } from "types/Provider";
import reducers from "./reducers";
import { createSlice } from "@reduxjs/toolkit";

const initialState: ProviderState = {
  providers: [],
  providersCards: [],
  providersCollection: [],
};

export const providerSlice = createSlice({
  name: "providers",
  initialState,
  reducers,
});

export const { setProviders, setProvidersCards, setProvidersCollection } =
  providerSlice.actions;

export default providerSlice.reducer;
